import './pbmPromotion.scss';

import { useEffect, useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';

import { useOrderContext } from '@/resources/hooks/useOrderContext';
import { useWebContext } from '@/resources/hooks/useWebContext';
import { getPbmDiscountCheck } from '@/routes/products';
import { ICartProduct } from '@/store/ducks/order/types';
import { IAlert, IPbmCheckResponse } from '@/store/ducks/products/types';

import PbmIcon from './PbmIcon';
import { PbmPromotionsModal } from './PromotionsModal';

interface IPbmInlineProps {
  item: ICartProduct;
  pbmPromotions?: IAlert[];
}

export function PbmInLine({ item, pbmPromotions }: IPbmInlineProps) {
  const { configs, order } = useWebContext();
  const { setFunction } = useOrderContext();
  const [showPromotionsModal, setShowPromotionsModal] = useState(false);
  const [promotions, setPromotions] = useState<IAlert[]>([]);

  const history = useHistory();
  const color = configs.pbm_price_color;
  const onHide = () => {
    setShowPromotionsModal(false);
  };

  useEffect(() => {
    const unblock = history.block(() => {
      if (showPromotionsModal) {
        return false;
      }
      return undefined;
    });

    return () => {
      unblock();
    };
  }, [showPromotionsModal, history]);

  useEffect(() => {
    setFunction('setShowPbmModal', setShowPromotionsModal);
  }, [showPromotionsModal]);

  useEffect(() => {
    if (pbmPromotions && pbmPromotions.length > 0) {
      setPromotions(pbmPromotions);
    }
  }, [pbmPromotions]);

  const product = order?.cart.products.find((p) => p.id === item.id) || item;

  const getDiscounts = async () => {
    const response: IPbmCheckResponse | any = await getPbmDiscountCheck({
      order_id: order?.id as number,
      full_product_id: product?.id as number,
      ean: product?.ean as string,
      quantity: 1,
    });
    if (response?.prices) {
      setPromotions(response.prices);
      setShowPromotionsModal(true);
    }
  };

  return (
    <>
      <button
        type="button"
        style={{ borderColor: color, color }}
        className="pbm-inline"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onClickCapture={async (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (pbmPromotions?.length || product?.id) await getDiscounts();
        }}
      >
        <PbmIcon color={color} />
        <div className="align-items-center">
          Desconto de Lab. <FaCheckCircle color="green" />
        </div>
      </button>

      <PbmPromotionsModal
        product={product}
        color={color}
        promotions={promotions}
        isCart
        show={showPromotionsModal}
        onHide={() => onHide()}
      />
    </>
  );
}
